import { RetailSales } from "../features/retail/pages/retail-sales"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function RetailSalesPage() {
  return (
    <DashboardLayout>
      <RetailSales />
    </DashboardLayout>
  )
}
